import { FunctionComponentElement } from 'react';
import reactDom from 'react-dom';

export function openPrintDialogForComponent(component: FunctionComponentElement<any>) {
  let printIframe = document.getElementById('for-print') as HTMLIFrameElement;
  if (!printIframe) {
    printIframe = document.createElement('iframe');
    printIframe.id = 'for-print';
    document.body.appendChild(printIframe);
  }
  const contentContainer = document.createElement('div');
  reactDom.render(component, contentContainer);
  const contentWindow = printIframe.contentWindow as any;
  contentWindow.document.open();
  contentWindow.document.write(contentContainer.innerHTML);
  contentWindow.document.close();
  contentWindow.focus();
  contentWindow.print();
}
